import '../boot'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from "@/app-layout-mixin";

createApp({
    mixins: [ AppLayoutMixin ],
}).mount('#app')
